module.exports = __webpack_public_path__ + "img/result_ls_lens_down.8670a561.jpg";